import { serviceHandler } from '../service-executor';

const LEG_URL = '/api/otr/legs';

export const deleteLeg = legId => {
  const URL = `${LEG_URL}/${legId}`;
  return serviceHandler(URL, 'DELETE');
};

export const save = leg => {
  const URL = `${LEG_URL}/save`;
  return serviceHandler(URL, 'POST', leg);
};

export const getLeg = legId => {
  const URL = `${LEG_URL}/${legId}`;
  return serviceHandler(URL, 'GET');
};

export const assignDriver = (legId, driver) => {
  const URL = `${LEG_URL}/${legId}/drivers/assign`;
  return serviceHandler(URL, 'POST', driver);
};

export const unassignDriver = (legId, driverId) => {
  const URL = `${LEG_URL}/${legId}/drivers/${driverId}/unassign`;
  return serviceHandler(URL, 'POST');
};

export const changeDriver = (legId, driver) => {
  const URL = `${LEG_URL}/${legId}/drivers/${driver.id}/change`;
  return serviceHandler(URL, 'POST', driver);
};

/** Driver Base Rate */
export const updateLegRate = (legId, driverRateModel) => {
  const driverId = driverRateModel.id;
  const URL = `${LEG_URL}/${legId}/driverRate/${driverId}/update`;
  return serviceHandler(URL, 'POST', driverRateModel);
};

/** Leg Charges APIs */
// export const getLegCharges = (legId, driverId) => {
//   const URL = `${LEG_URL}/${legId}/${driverId}/charges`;
//   return serviceHandler(URL, 'GET');
// };

export const saveLegCharges = (legId, driverId, legCharge) => {
  const URL = `${LEG_URL}/${legId}/${driverId}/charges/save`;
  return serviceHandler(URL, 'POST', legCharge);
};

export const updateLegCharges = (legId, legCharge) => {
  const URL = `${LEG_URL}/${legId}/charges/update`;
  return serviceHandler(URL, 'PUT', legCharge);
};

export const deleteLegCharge = (legId, chargeId) => {
  const URL = `${LEG_URL}/${legId}/charges/${chargeId}/delete`;  
  return serviceHandler(URL, 'DELETE');
};

export const getNextStatus = (legId) => {
  const URL = `${LEG_URL}/${legId}/nextstatus`;
  return serviceHandler(URL, 'GET');
};

export const getDestinationStatusTime = (legId, consigneeId) => {
  const URL = `${LEG_URL}/${Number.parseInt(legId)}/consignee/${consigneeId}/status-info`;
  return serviceHandler(URL, 'GET');
};

